<script lang="ts" setup>
import AppMenuItem from './AppMenuItem.vue'
import type { MenuItem } from 'primevue/menuitem'

const { currentOrganization, organizationCounts } = useOrganization()
const { hasModuleAccess, isAdmin } = useAuth()

const model = computed<MenuItem[]>(() => {
  const items = [
    {
      label: 'Home',
      items: [
        {
          label: 'Dashboard',
          icon: 'pi pi-fw pi-home',
          command: () => navigateTo('/manager/projects'),
        },
      ],
    },
  ]

  if (currentOrganization.value) {
    if (hasModuleAccess('manager')) {
      items[0]?.items.push({
        label: 'Pending to collect',
        icon: 'pi pi-dollar',
        command: () => navigateTo('/manager/to-collect'),
      })

      items.push({
        label: 'Manager',
        items: [
          {
            label: 'Contracts',
            icon: 'pi pi-fw pi-file',
            command: () => navigateTo('/manager/contracts'),
          },
          {
            label: 'Projects',
            icon: 'pi pi-fw pi-briefcase',
            command: () => navigateTo('/manager/projects'),
          },
          {
            label: 'Customers',
            icon: 'pi pi-fw pi-users',
            command: () => navigateTo('/manager/customers'),
          },
          {
            label: 'Adjusters',
            icon: 'pi pi-fw pi-star',
            command: () => navigateTo('/manager/adjusters'),
          },
          {
            label: 'Conversations',
            icon: 'pi pi-fw pi-comments',
            command: () => navigateTo('/manager/conversations'),
          },
        ],
      })
    }

    if (hasModuleAccess('scheduling')) {
      items.push({
        label: 'Scheduling',
        items: [
          {
            label: 'Projects',
            icon: 'pi pi-fw pi-briefcase',
            command: () => navigateTo('/scheduling/projects'),
          },
          {
            label: 'Weekly Schedule',
            icon: 'pi pi-fw pi-bolt',
            command: () => navigateTo('/scheduling/weekly-schedule'),
          },
          {
            label: 'Crews & Route',
            icon: 'pi pi-fw pi-users',
            command: () => navigateTo('/scheduling/crews-route'),
          },
        ],
      })
    }

    if (hasModuleAccess('comms')) {
      items.push({
        label: 'Comms',
        items: [
          {
            label: 'Stats',
            icon: 'pi pi-fw pi-chart-bar',
            command: () => navigateTo('/comms/stats'),
          },
          {
            label: 'Calls',
            icon: 'pi pi-fw pi-phone',
            command: () => navigateTo('/comms/calls'),
          },
          {
            label: 'Blasts',
            icon: 'pi pi-fw pi-megaphone',
            command: () => navigateTo('/comms/blasts'),
          },
        ],
      })
    }

    if (hasModuleAccess('crm')) {
      items.push({
        label: 'CRM',
        items: [
          {
            label: 'Campaigns',
            icon: 'pi pi-fw pi-briefcase',
            command: () => navigateTo('/crm/campaigns'),
          },
          {
            label: 'Leads',
            icon: 'pi pi-fw pi-users',
            command: () => navigateTo('/crm/leads'),
          },
          {
            // @ts-ignore
            badge: organizationCounts.value?.crm_conversations,
            label: 'Conversations',
            icon: 'pi pi-fw pi-comments',
            command: () => navigateTo('/crm/conversations'),
            badgeSeverity: 'danger',
          },
        ],
      })
    }

    if (isAdmin()) {
      items.push({
        label: 'Configuration',
        items: [
          {
            label: 'Users',
            icon: 'pi pi-fw pi-user',
            command: () => navigateTo('/users'),
          },
          {
            label: 'Setup',
            icon: 'pi pi-fw pi-wrench',
            command: () => navigateTo('/setup'),
          },
        ],
      })
    }
  }

  return items
})
</script>

<template>
  <ul class="layout-menu">
    <template v-for="(item, i) in model" :key="i">
      <app-menu-item
        v-if="!item.separator"
        :item="item"
        :index="i"
      ></app-menu-item>
      <li v-if="item.separator" class="menu-separator"></li>
    </template>
  </ul>
</template>
